<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>User Wallet History: {{username}}</h4>
            </div>
            <div class="rightDiv">
                <button class="addBTn" (click)="addNewWallet()"> <span><img
                            src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Load User
                    Wallet</button>
                <button class="addBTn" (click)="subtractNewWallet()"> <span><img
                            src="../../../assets/images/backend-image/header/minus.svg" alt=""></span> Unload User
                    Wallet</button>

                <button class="exportBTn" (click)="exportExcel()">
                    <span>
                        <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                    </span> Export
                </button>
            </div>
        </div>
        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar placeholder="From: dd / mm / yy" appendTo="body" monthNavigator="true"
                            yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate" class="p-calendar w-100"
                            inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <p-calendar placeholder="To: dd / mm / yy" appendTo="body" monthNavigator="true"
                            yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate" class="p-calendar"
                            inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <button (click)="loadWalletHistory($event)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <button class="clearFilterBtn" (click)="clear()">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>

                    </li>
                </ul>

            </div>
            <div class="walletNote">
                <div class="Available-details">
                    <h5>Available Cash : {{totalAvailableCash | number:'1.2-2'}}</h5>
                    <span class="pipe"></span>
                    <h5>Available Coins : {{totalAvailableCoins | number:'1.2-2'}}</h5>
                </div>
            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class="p2-table-columns show-columns" #dt [value]="walletlist" [paginator]="true"
                        [rows]="10" [lazy]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords"
                        [loading]="loading" [rowsPerPageOptions]="paginationOption"
                        styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pSortableColumn="id" class="TransactionIdTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Transaction ID
                                        <p-sortIcon field="id"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="id" class="PaymentTd">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Razoropay Payment Id
                                        <p-sortIcon field="paymentId"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="description" class="DescriptionTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                                </th>
                                <th pSortableColumn="id" class="descriptionTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Tournament Category
                                        <p-sortIcon field="id"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="platformFeeAmount" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Platform Fee Amount
                                        <p-sortIcon field="platformFeeAmount"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="platformFeeRate" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Platform Fee Rate
                                        <p-sortIcon field="platformFeeRate"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="convenienceFeeAmount" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Convenience Fee Amount
                                        <p-sortIcon field="convenienceFeeAmount"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="convenienceFeeRate" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Convenience Fee Rate
                                        <p-sortIcon field="convenienceFeeRate"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="amount" class="AmountTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Amount
                                        <p-sortIcon field="amount"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="created_at" class="created_atTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Created Date
                                        <p-sortIcon field="created_at"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                                    colspan="1" style="justify-content: center;">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Action
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th [ngSwitch]="id" class="TransactionIdTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                        [value]="dt.filters['id'] ? dt.filters['id'].value : ''" />
                                </th>
                                <th [ngSwitch]="id" class="PaymentTd">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'paymentId', 'contains')"
                                        [value]="dt.filters['paymentId'] ? dt.filters['paymentId'].value : ''" />
                                </th>
                                <th [ngSwitch]="description" class="DescriptionTD">
                                </th>
                                <th [ngSwitch]="tournamentCategory" class="usernameTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCategory', 'contains')"
                                        [value]="dt.filters['tournamentCategory'] ? dt.filters['tournamentCategory'].value : ''" />
                                </th>
                                <th [ngSwitch]="platformFeeAmount" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'platformFeeAmount', 'contains')"
                                        [value]="dt.filters['platformFeeAmount'] ? dt.filters['platformFeeAmount'].value : ''" />
                                </th>
                                <th [ngSwitch]="platformFeeRate" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'platformFeeRate', 'contains')"
                                        [value]="dt.filters['platformFeeRate'] ? dt.filters['platformFeeRate'].value : ''" />
                                </th>
                                <th [ngSwitch]="convenienceFeeAmount" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'convenienceFeeAmount', 'contains')"
                                        [value]="dt.filters['convenienceFeeAmount'] ? dt.filters['convenienceFeeAmount'].value : ''" />
                                </th>
                                <th [ngSwitch]="convenienceFeeRate" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'convenienceFeeRate', 'contains')"
                                        [value]="dt.filters['convenienceFeeRate'] ? dt.filters['convenienceFeeRate'].value : ''" />
                                </th>
                                <th [ngSwitch]="amount" class="AmountTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
                                        [value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
                                </th>
                                <th [ngSwitch]="created_at" class="created_atTD">
                                </th>
                                <th class="text-nowrap p-element p-frozen-column action-button-td"  style="justify-content: center;">
                                    <div class="buttonColumn">
                                        <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                                            + Show Columns
                                        </button>
                                        <button class="removeBTn" (click)="removeColumns()"
                                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                                        - Hide Columns
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-userwallet>
                            <tr class="p-selectable-row">
                                <td class="TransactionIdTD">
                                    {{userwallet.id}}
                                </td>
                                <td class="PaymentTd">
                                    {{userwallet.paymentId}}
                                </td>
                                <td class="DescriptionTD">
                                    {{userwallet.description}}
                                </td>
                                <!-- <td *ngIf="userwallet.coins!=0">                                    
                            <div class="debit" *ngIf="userwallet.action=='ADD'">
                                <i class='pi pi-plus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase }}<span></span>
                            </div>
                            <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                <i class='pi pi-minus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase}} <span></span>
                            </div>
                            
                        </td>
                        <td *ngIf="userwallet.cash!=0">
                            <div class="debit" *ngIf="userwallet.action=='ADD'">
                                <i class='pi pi-plus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}}<span></span>
                            </div>
                            <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                <i class='pi pi-minus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}} <span></span>
                            </div>
                        </td> -->
                                <td class="usernameTD">
                                    {{userwallet?.tournamentCategory}}
                                </td>
                                <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <span class="AmountTD addText" *ngIf="userwallet?.action=='ADD'">+ ₹{{userwallet?.platformFeeAmount}}</span>
                                    <span class="AmountTD subText" *ngIf="userwallet?.action=='SUBTRACT'">- ₹{{userwallet?.platformFeeAmount}}</span>
                                </td>
                                <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <span class="AmountTD addText" *ngIf="userwallet?.action=='ADD'">+ {{ (userwallet?.platformFeeType === 'flat') ? '₹' : ''}}{{userwallet?.platformFeeRate}}{{ (userwallet?.platformFeeType === 'percentage') ? '%' : ''}}</span>
                                    <span class="AmountTD subText" *ngIf="userwallet?.action=='SUBTRACT'">- {{ (userwallet?.platformFeeType === 'flat') ? '₹' : ''}}{{userwallet?.platformFeeRate}}{{ (userwallet?.platformFeeType === 'percentage') ? '%' : ''}}</span>
                                </td>
                                <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <span class="AmountTD addText" *ngIf="userwallet?.action=='ADD'">+ ₹{{userwallet?.convenienceFeeAmount}}</span>
                                    <span class="AmountTD subText" *ngIf="userwallet?.action=='SUBTRACT'">- ₹{{userwallet?.convenienceFeeAmount}}</span>
                                </td>
                                <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <span class="AmountTD addText" *ngIf="userwallet?.action=='ADD'">+ {{ (userwallet?.convenienceFeeType === 'flat') ? '₹' : ''}}{{userwallet?.convenienceFeeRate}}{{ (userwallet?.convenienceFeeType === 'percentage') ? '%' : ''}}</span>
                                    <span class="AmountTD subText" *ngIf="userwallet?.action=='SUBTRACT'">- {{ (userwallet?.convenienceFeeType === 'flat') ? '₹' : ''}}{{userwallet?.convenienceFeeRate}}{{ (userwallet?.convenienceFeeType === 'percentage') ? '%' : ''}}</span>
                                </td>
                                <td *ngIf="userwallet.action=='ADD'" class="AmountTD addText">
                                    + {{userwallet.amount ?? 0}} {{userwallet.wallettype | lowercase }}
                                </td>
                                <td *ngIf="userwallet.action=='SUBTRACT'" class="AmountTD subText">
                                    - {{userwallet.amount ?? 0}} {{userwallet.wallettype | lowercase }}
                                </td>
                                <td class="created_atTD">
                                    {{userwallet.created_at | date:'d/M/yyyy'}}
                                </td>
                                <td class="actionTD p-frozen-column">
                                    <ul class="actionList">
                                        <li *ngIf="userwallet.created_by === loggedInUserId">
                                            <button pTooltip="Delete User Wallet Entry"
                                                (click)="deleteUserWalletEntry(userwallet)" class="deleteBtn"><img
                                                    src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                        </li>
                                        <li>
                                            <i *ngIf="userwallet.invoiceFile" pTooltip="Click to view Invoice PDF"
                                                class="bx bxs-file-pdf" style="color: red; font-size: 18px"
                                                (click)="downloadPdf(userwallet.invoiceFile)"></i>
                                            <i *ngIf="userwallet.creditInvoiceFile" pTooltip="Click to view Invoice PDF"
                                                class="bx bxs-file-pdf" style="color: red; font-size: 18px"
                                                (click)="downloadPdf(userwallet.creditInvoiceFile)"></i>
                                        </li>
                                    </ul>
                                </td>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="5">No Wallet History.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

    </div>
</div>
<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>